import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom';
import { Button, Dialog, DialogActions, DialogContent, Paper, PaperProps } from '@material-ui/core'
import { Card, CardActionArea, CardActions, CardContent, CircularProgress, Grid, TextField, List, ListItem, ListItemText } from '@material-ui/core'
import Draggable from 'react-draggable';
import { Autocomplete } from '@material-ui/lab'
import Alert from '@material-ui/lab/Alert/Alert';
import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Separator } from 'office-ui-fabric-react';
import IViewAranceles from "../../presentation/view-interfaces/IViewAranceles";
import TransformarMiles from "../../presentation/util/TransformarMiles"
import DetalleBeneficio from '../../presentation/view-model/Modals/DetalleBeneficio';
import DetallePagado from '../../presentation/view-model/Modals/DetallePagado';
const { validarRUT } = require('validar-rut')
const { formatterRut, cleanRut } = require('chilean-formatter')
type Props = {
    detalleAranceles: any;
    className: string;
}
const DetalleMontoAranceles: React.FC<Props> = ({ detalleAranceles, className }) => {
    const history = useHistory();
    const location = useLocation();
    const [beca, setBeca] = useState({ beca: [], estado: false });
    const [pagado, setPagado] = useState(false);

    function transformarMiles(valor: string) {
        const valor1 = valor + "";
        let retornar = "0";
        var splitValor;
        if (valor !== "0") {
            if (valor1.indexOf('.') === -1) {
                retornar = parseInt(valor1).toLocaleString();
            } else {
                splitValor = valor1.split('.');
                retornar = parseInt(splitValor[0]).toLocaleString();
            }
        }
        return retornar;
    }
    const panelBeneficio = (beneficio: any) => {
        return (
            "a"
        )
    }
    return (
        <>
            <table className={className}>
                <thead>
                    <th className="text-center w-30" > </th>
                    {
                        detalleAranceles.arancelCodigoMoneda !== 1 ?
                            <th className="text-center w-20 noWrap" > {detalleAranceles.arancelCodigoMoneda === 2 ? 'UF' : 'USD'
                            } </th>
                            :
                            ""
                    }
                    <th className="text-center w-20" > CLP </th>
                    < th className="text-center w-30" > </th>
                </thead>
                <tfoot>
                    <tr>
                        <td className="w-30" > Valor </td>
                        {
                            detalleAranceles.arancelCodigoMoneda !== 1 ?
                                <td style={{ whiteSpace: 'nowrap' }} className="text-center w-20" > {`${parseFloat(detalleAranceles.arancelMontoOriginal).toFixed(2)}`} </td>
                                :
                                ""
                        }
                        <td className="text-center w-20 " > {`$${transformarMiles((detalleAranceles.arancelMontoCLP))}`} </td>
                        <td></td>
                    </tr>
                    {
                        detalleAranceles.sumaBeneficioInternoCLP !== 0 ?
                            <tr>
                                <td className="w-30" > &nbsp;&nbsp;Beneficio Interno </td>
                                {
                                    detalleAranceles.arancelCodigoMoneda !== 1 ?
                                        <td style={{ whiteSpace: 'nowrap' }} className="text-center w-20" > {`${parseFloat(detalleAranceles.sumaBeneficioInterno).toFixed(2)}`} </td>
                                        :
                                        ""
                                }
                                <td className="text-center w-20 " > {`$${transformarMiles(detalleAranceles.sumaBeneficioInternoCLP)}`}</td>
                                <td>
                                    <a style={{ textDecoration: 'underline', color: '#0062a1', cursor: 'pointer' }}
                                        onClick={() => { setBeca({ beca: detalleAranceles.beneficioInterno, estado: true }) }}>
                                        Ver Detalle
                                    </a>
                                </td >
                            </tr>
                            :
                            ""
                    }
                    {
                        detalleAranceles.sumaBeneficioExternoCLP !== 0 ?
                            <tr>
                                <td className="w-30">  &nbsp;&nbsp;Beneficio Externo</td>
                                {
                                    detalleAranceles.arancelCodigoMoneda !== 1 ?
                                        <td style={{ whiteSpace: 'nowrap' }} className="text-center w-20" > {`${parseFloat(detalleAranceles.sumaBeneficioExterno).toFixed(2)}`} </td>
                                        :
                                        ""
                                }
                                <td className="text-center w-20 " > {`$${transformarMiles(detalleAranceles.sumaBeneficioExternoCLP)}`}</td>
                                <td>
                                    <a style={{ textDecoration: 'underline', color: '#0062a1', cursor: 'pointer' }}
                                        onClick={() => { setBeca({ beca: detalleAranceles.beneficioExterno, estado: true }) }}>
                                        Ver Detalle
                                    </a>
                                </td >
                            </tr>
                            :
                            ""
                    }
                    {
                        detalleAranceles.sumaCAECLP !== 0 ?
                            <tr>
                                <td className="w-30">  &nbsp;&nbsp;CAE</td>
                                {
                                    detalleAranceles.arancelCodigoMoneda !== 1 ?
                                        <td style={{ whiteSpace: 'nowrap' }} className="text-center w-20" > {`${parseFloat(detalleAranceles.sumaCAE).toFixed(2)}`} </td>
                                        :
                                        ""
                                }
                                <td className="text-center w-20 " > {`$${transformarMiles(detalleAranceles.sumaCAECLP)}`}</td>
                            </tr>
                            :
                            ""
                    }
                    {
                        detalleAranceles.comprobanteFacturacionCLP !== 0 ?
                            <tr>
                                <td className="w-30"> &nbsp;&nbsp;Comprobante Facturación</td>
                                {
                                    detalleAranceles.arancelCodigoMoneda !== 1 ?
                                        <td style={{ whiteSpace: 'nowrap' }} className="text-center w-20" > {`${parseFloat(detalleAranceles.comprobanteFacturacion).toFixed(2)}`} </td>
                                        :
                                        ""
                                }
                                <td className="text-center w-20 " > {`$${transformarMiles(detalleAranceles.comprobanteFacturacionCLP)}`}</td>
                            </tr>
                            :
                            ""
                    }
                    {/* {
                        detalleAranceles.sumaPagadoCLP !== 0 ? */}
                    <tr>
                        <td className="w-30"> &nbsp;&nbsp;Pagado</td>
                        {
                            detalleAranceles.arancelCodigoMoneda !== 1 ?
                                <td style={{ whiteSpace: 'nowrap' }} className="text-center w-20" > {`${parseFloat(detalleAranceles.sumaPagado).toFixed(2)}`} </td>
                                :
                                ""
                        }
                        <td className="text-center w-20 " > {`$${transformarMiles(detalleAranceles.sumaPagadoCLP)}`}</td>
                        <td>
                            <a style={{ textDecoration: 'underline', color: '#0062a1', cursor: 'pointer' }}
                                onClick={() => { setPagado(true) }}>
                                Ver Detalle
                            </a>
                        </td >
                    </tr>
                    {/* :
                            ""
                    } */}
                    {
                        detalleAranceles.pagado.desctPagoContado != null && detalleAranceles.pagado.desctPagoContado != undefined ?
                            <tr>
                                <td className="w-30"> &nbsp;&nbsp;Desct. Pago Contado</td>
                                {
                                    detalleAranceles.arancelCodigoMoneda !== 1 ?
                                        <td style={{ whiteSpace: 'nowrap' }} className="text-center w-20" > {`${parseFloat(detalleAranceles.pagado.desctPagoContado.monto).toFixed(2)}`} </td>
                                        :
                                        ""
                                }
                                <td className="text-center w-20 " > {`$${transformarMiles(detalleAranceles.pagado.desctPagoContado.montoCLP)}`}</td>
                            </tr>
                            :
                            ""
                    }
                    <tr>
                        <td className="w-30" > <strong>Total Pagar</strong></td>
                        {
                            detalleAranceles.arancelCodigoMoneda !== 1 ?
                                <td style={{ whiteSpace: 'nowrap' }} className="text-center w-20 " > <strong>{`${detalleAranceles.arancelSaldoFinalOriginal > -1 && detalleAranceles.arancelSaldoFinalOriginal < 0 ? 0 : parseFloat(detalleAranceles.arancelSaldoFinalOriginal).toFixed(2)}`}</strong></td >
                                :
                                ""
                        }
                        <td className="text-center w-20 " > <strong>{`$${transformarMiles(detalleAranceles.arancelSaldoFinalCLP > -1 && detalleAranceles.arancelSaldoFinalCLP < 0 ? 0 : detalleAranceles.arancelSaldoFinalCLP)}`}</strong></td >
                        <td></td>
                    </tr>
                </tfoot>
            </table>
            <DetalleBeneficio beneficio={beca.beca} onClick={() => { setBeca({ beca: [], estado: false }) }} estado={beca.estado} moneda={detalleAranceles.arancelCodigoMoneda}></DetalleBeneficio>
            <DetallePagado pagado={detalleAranceles.pagado} onClick={() => { setPagado(false) }} estado={pagado} ></DetallePagado>
        </>
    )
}

export default DetalleMontoAranceles;